import { AxiosInstance } from 'axios';
import { axiosWithoutCaseMiddleware } from '@/helpers/forms/axios';

export default (axios: AxiosInstance = axiosWithoutCaseMiddleware): { convertToArray: (file: File) => Promise<Array<Record<string, unknown>>>; } => ({
    convertToArray: async (file: File): Promise<Array<Record<string, unknown>>> => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await axios.post('/api/spreadsheets/to-array', formData);

        return response.data;
    },
});
